import { useState, useLayoutEffect } from 'react';
import { MAIN_CONTENT_SIZE } from '../constants';

export const useMainContentSize = (): number[] => {
  const [mainContentSize, setMainContentSize] = useState<number[]>(MAIN_CONTENT_SIZE.M);

  useLayoutEffect(() => {
    const updateSize = () => {
      const { innerWidth } = window;
      if (innerWidth <= 1366) {
        setMainContentSize(MAIN_CONTENT_SIZE.S);
      } else if (innerWidth >= 2046) {
        setMainContentSize(MAIN_CONTENT_SIZE.L);
      } else {
        setMainContentSize(MAIN_CONTENT_SIZE.M);
      }
    };
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return mainContentSize;
};
